// src/store/reducers/appReducer.js
import {
  SUBMIT_BOOKING_FORM_REQUEST,
  SUBMIT_BOOKING_FORM_SUCCESS,
  SUBMIT_BOOKING_FORM_FAILURE,
  SET_CHECKSUM,
  FETCH_CITIES_REQUEST,
  FETCH_CITIES_SUCCESS,
  FETCH_CITIES_FAILURE,
  SET_SELECTED_CITY,
  FETCH_HERITAGES_REQUEST,
  FETCH_HERITAGES_SUCCESS,
  FETCH_HERITAGES_FAILURE,
  FETCH_HERITAGE_BOOKING_REQUEST,
  FETCH_HERITAGE_BOOKING_SUCCESS,
  FETCH_HERITAGE_BOOKING_FAILURE,
  RESET_HERITAGE_BOOKING_LOADING,
  INIT_PAYMENT_API_REQUEST,
  INIT_PAYMENT_API_SUCCESS,
  INIT_PAYMENT_API_FAILURE,
  PAYMENT_REQUEST,
  PAYMENT_SUCCESS,
  PAYMENT_FAILURE,
  FETCH_PREVIOUS_BOOKINGS_REQUEST,
  FETCH_PREVIOUS_BOOKINGS_SUCCESS,
  FETCH_PREVIOUS_BOOKINGS_FAILURE
} from "../actions/culturalHeritageAction";

import { AesECBDecryptt } from "../../utills/encryption";
import {
  CH_ONDC_AES_KEY,
  CH_MPCZ_AES_KEY,
  REACT_APP_CH_KMC_AUTH_TOKEN,
  REACT_APP_CH_MSEDCL_AUTH_TOKEN,
  REACT_APP_CH_ONDC_AUTH_TOKEN,
  REACT_APP_CH_MSEDCL_EMP_AUTH_TOKEN,
  REACT_APP_CH_MPCZ_AUTH_TOKEN,
  REACT_APP_AES_KEY_MSEDCL,
} from "../../utills/constants";

/* -------------------------------------------------
   INITIAL STATE
------------------------------------------------- */
const initialState = {
  bookingForm: {
    loading: false,
    data: [],
    error: null,
  },
  checksum: {
    whatsappAccount: "",
    acceptLanguage: "",
    timeStamp: "",
    merchantCode: "",
    token: "",
    rawChecksum: null,
  },
  city: {
    cities: [],
    loading: false,
    error: null,
    selectedCity: null,
  },
  heritage: {
    loading: false,
    heritages: [],
    error: null,
  },
  heritageBooking: {
    loading: false,
    booking: null,
    error: null,
  },
  initPayment: {
    loading: false,
    data: null,
    error: null,
  },
  payment: {
    loading: false,
    data: null,
    error: null,
  },
  previousBookingsData: {
    loading: false,
    data: [],
    error: null,
  },
};

/* -------------------------------------------------
   ROOT REDUCER
------------------------------------------------- */
const culturalHeritageReducer = (state = initialState, action) => {
  switch (action.type) {
    /* BOOKING FORM */
    case SUBMIT_BOOKING_FORM_REQUEST:
      return { ...state, bookingForm: { ...state.bookingForm, loading: true, error: null } };
    case SUBMIT_BOOKING_FORM_SUCCESS:
      return { ...state, bookingForm: { ...state.bookingForm, loading: false, data: action.payload, error: null } };
    case SUBMIT_BOOKING_FORM_FAILURE:
      return { ...state, bookingForm: { ...state.bookingForm, loading: false, data: null, error: action.payload } };

    /* CHECKSUM */
    case SET_CHECKSUM: {
      const checksum = action.payload;
      let { whatsappAccount, acceptLanguage, timeStamp } = state.checksum;
      let merchantCode;
      const tryDecrypt = (key) => {
        try {
          const decrypted = AesECBDecryptt(key, atob(checksum));
          if (typeof decrypted === "string") {
            const parts = decrypted.split("|");
            if (parts.length >= 3) {
              whatsappAccount = parts[0];
              acceptLanguage = parts[1];
              timeStamp = parts[2];
              merchantCode = parts[3];
              return true;
            }
          }
        } catch (_) {}
        return false;
      };
      if (!tryDecrypt(CH_ONDC_AES_KEY)) {
        if (!tryDecrypt(CH_MPCZ_AES_KEY)) {
          tryDecrypt(REACT_APP_AES_KEY_MSEDCL);
        }
      }
      let token;
      if (merchantCode === "kmc") {
        token = REACT_APP_CH_KMC_AUTH_TOKEN;
      } else if (merchantCode === "clht") {
        token = REACT_APP_CH_ONDC_AUTH_TOKEN;
      } else if (merchantCode === "MPCZ") {
        token = REACT_APP_CH_MPCZ_AUTH_TOKEN;
      } else if (timeStamp === "mseemp" || merchantCode === "mseemp") {
        token = REACT_APP_CH_MSEDCL_EMP_AUTH_TOKEN;
      } else {
        token = REACT_APP_CH_MSEDCL_AUTH_TOKEN;
      }
      return {
        ...state,
        checksum: {
          ...state.checksum,
          rawChecksum: checksum,
          whatsappAccount,
          acceptLanguage,
          timeStamp,
          merchantCode: merchantCode || "",
          token,
        },
      };
    }

    /* CITY */
    case FETCH_CITIES_REQUEST:
      return { ...state, city: { ...state.city, loading: true, error: null } };
    case FETCH_CITIES_SUCCESS:
      return { ...state, city: { ...state.city, loading: false, cities: action.payload } };
    case FETCH_CITIES_FAILURE:
      return { ...state, city: { ...state.city, loading: false, error: action.payload } };
    case SET_SELECTED_CITY:
      return { ...state, city: { ...state.city, selectedCity: action.payload } };

    /* HERITAGES */
    case FETCH_HERITAGES_REQUEST:
      return { ...state, heritage: { ...state.heritage, loading: true, error: null } };
    case FETCH_HERITAGES_SUCCESS:
      return { ...state, heritage: { ...state.heritage, loading: false, heritages: action.payload, error: null } };
    case FETCH_HERITAGES_FAILURE:
      return { ...state, heritage: { ...state.heritage, loading: false, heritages: [], error: action.payload } };

    /* HERITAGE BOOKING */
    case FETCH_HERITAGE_BOOKING_REQUEST:
      return { ...state, heritageBooking: { ...state.heritageBooking, loading: true, error: null } };
    case FETCH_HERITAGE_BOOKING_SUCCESS:
      return { ...state, heritageBooking: { ...state.heritageBooking, loading: false, booking: action.payload } };
    case FETCH_HERITAGE_BOOKING_FAILURE:
      return { ...state, heritageBooking: { ...state.heritageBooking, loading: false, error: action.payload } };
    case RESET_HERITAGE_BOOKING_LOADING:
      return { ...state, heritageBooking: { ...state.heritageBooking, loading: false, error: null } };

    /* INITIALIZE PAYMENT */
    case INIT_PAYMENT_API_REQUEST:
      return { ...state, initPayment: { ...state.initPayment, loading: true, error: null } };
    case INIT_PAYMENT_API_SUCCESS:
      return { ...state, initPayment: { ...state.initPayment, loading: false, data: action.payload } };
    case INIT_PAYMENT_API_FAILURE:
      return { ...state, initPayment: { ...state.initPayment, loading: false, error: action.payload } };

    /* PAYMENT */
    case PAYMENT_REQUEST:
      return { ...state, payment: { ...state.payment, loading: true, error: null } };
    case PAYMENT_SUCCESS:
      return { ...state, payment: { ...state.payment, loading: false, data: action.payload, error: null } };
    case PAYMENT_FAILURE:
      return { ...state, payment: { ...state.payment, loading: false, error: action.payload } };
    /* PREVIOUS BOOKINGS */
    case FETCH_PREVIOUS_BOOKINGS_REQUEST:
      return { ...state, previousBookingsData: { ...state.previousBookingsData, loading: true, error: null } };
    case FETCH_PREVIOUS_BOOKINGS_SUCCESS:
      return { ...state, previousBookingsData: { ...state.previousBookingsData, loading: false, data: action.payload, error: null } };
    case FETCH_PREVIOUS_BOOKINGS_FAILURE:
      return { ...state, previousBookingsData: { ...state.previousBookingsData, loading: false, data: [], error: action.payload } };

    default:
      return state;
  }
};

export default culturalHeritageReducer;
